
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const mfSeriesMeter: IProductData = {
  id: "purple-audio-meter",
  name: "Purple Audio MF Series Meter Bridge",
  description: "Meter bridge designed for the MF series console",
  specialOrder: true,
  images: ["/img/purpleaudio_meter_front.jpg", "/img/purpleaudio_meter_back.jpg"],
  details: [{
    label: "Description",
    markdown: `
The MF Series Meter Bridge has 11 pairs of LED meters, 10 inputs, and 1 stereo master meter.  
The Meter Bridge was designed for use with the MF Series Console, however, everything in this series can also be used with your existing gear as a standalone piece.    
Four selectable modes show: VU, Peak, OVR and Peak OVR..
`
    }, {
    label: "Specifications",
    markdown: `
2RU Meter unit comes in to varieties:    
Single DB-25 input for use with the MFTwenty5, with cable.  
Three DB-25 stacked input for use with a standard balanced 8 Pair Cables.  
For use as remote metering for DAW, Tape Machines, 5.1 or 7.1 Metering, Stereo source metering, etc.  
The inputs 1-8, 9-16, 17-22 are multed with 100k input impedance so no additional patch or mult is needed to insert in signal path.  
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://purpleaudio.com/products/mf-twenty-25/" target="_blank">https://purpleaudio.com/products/mf-twenty-25/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.MIXING, HASHTAGS.LIVE_SOUND, HASHTAGS.MASTERING],
    manufacturer: BRAND.PURPLE_AUDIO,
  },
  videos: []
}